// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__2x+Tr","Cancel":"schedule_Cancel__CSNRh"};